import { ButtonColor } from './action-buttons.types';

/**
 * Shared OriBot chat-button entry. Every page that shows the assistant
 * plugs this into its own `actionButtons` array so the icon / color /
 * tooltip stay in lockstep across modules. Callers pass their own enum
 * value for `name` so their `handleActionClicked` switch keeps its
 * exhaustive-check.
 *
 * @example
 *   contactActionButtons: ContactsActionButton[] = [
 *     ...contactButtons,
 *     chatbotActionButton(ContactsActionName.CHATBOT),
 *   ];
 */
export const chatbotActionButton = <TName extends string>(
  name: TName,
): {
  color: ButtonColor;
  name: TName;
  svgIcon: string;
  tooltipKey: string;
} => ({
  color: ButtonColor.OriBot,
  name,
  svgIcon: 'oribot',
  tooltipKey: 'chatbot.tooltip',
});
